"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var i18next_1 = __importDefault(require("i18next"));
var react_redux_1 = require("react-redux");
var core_1 = require("@material-ui/core");
var react_router_dom_1 = require("react-router-dom");
var go_main_logo_svg_1 = __importDefault(require("@assets/go-logo-graphics/go-main-logo.svg"));
var login_page_graphics_svg_1 = __importDefault(require("@assets/login-page-graphics/login-page-graphics.svg"));
var asset_variant_1 = __importDefault(require("../../shared/util/asset-variant"));
var actions_1 = __importDefault(require("./actions"));
var actions_2 = __importDefault(require("../app/components/pages/RootPage/actions"));
var format_1 = require("../app/util/format");
var types_1 = require("../app/util/types");
var requests_1 = require("../app/util/requests");
var LoginForm_1 = __importDefault(require("./components/LoginForm"));
var Section_1 = __importDefault(require("../app/components/Section"));
var BaseLayout_1 = __importDefault(require("../app/components/BaseLayout"));
var ga_1 = require("../app/util/ga");
var TextButton_1 = __importDefault(require("./widgets/TextButton"));
var useStyles = core_1.makeStyles(function (theme) {
    var _a, _b, _c;
    return core_1.createStyles({
        container: {
            display: 'flex',
            flexGrow: 1,
            '-ms-flex': '1 1 auto',
        },
        loginContainer: (_a = {
                display: 'flex',
                width: '100%'
            },
            _a[theme.breakpoints.up('lg')] = {
                width: '50%',
            },
            _a),
        verticalAlign: (_b = {
                display: 'flex',
                width: '100%'
            },
            _b[theme.breakpoints.up('lg')] = {
                alignItems: 'center',
            },
            _b),
        loginWrapper: (_c = {
                display: 'block'
            },
            _c[theme.breakpoints.up('lg')] = {
                // Gives the contents slightly more than enough height,
                // so that validation messages do not shift the centering.
                height: '400px',
                maxHeight: '80vh',
            },
            _c),
        headerGroup: {
            marginBottom: theme.spacing(4),
        },
        logo: {
            maxWidth: '130px',
            width: '40%',
        },
        loginHeader: {
            marginTop: theme.spacing(1),
        },
        loginReferral: {
            fontSize: '0.85rem',
            color: '#767676',
            marginBottom: theme.spacing(4),
        },
        textInputGroup: {
            marginBottom: theme.spacing(4),
        },
        graphicColorFill: {
            backgroundColor: theme.palette.primary.dark,
            width: '50vw',
            height: '100%',
            // allocates space for the government masthead when on gov variant
            maxHeight: asset_variant_1.default === 'gov' ? 'calc(100vh - 28px)' : '100vh',
            textAlign: 'center',
            overflow: 'hidden',
        },
        loginGraphic: {
            userDrag: 'none',
            height: '100%',
        },
        '@media screen\\0': {
            // Styles for Internet Explorer compatibility
            logoLink: {
                marginBottom: '0',
            },
        },
        secondaryButton: {
            fontWeight: 400,
            marginLeft: theme.spacing(2),
        },
        resendOTPBtn: {
            marginRight: 'auto',
            '&:disabled': {
                opacity: 0.5,
            },
        },
    });
});
var LoginPage = function (_a) {
    var _b, _c;
    var _d = _a.location, location = _d === void 0 ? undefined : _d;
    var classes = useStyles();
    var dispatch = react_redux_1.useDispatch();
    var getEmailValidator = dispatch(actions_1.default.getEmailValidationGlobExpression());
    var setLoginInfoMessage = function (message) {
        return dispatch(actions_2.default.setInfoMessage(message));
    };
    var emailValidator = react_redux_1.useSelector(function (state) { return state.login.emailValidator; });
    var isLoggedIn = react_redux_1.useSelector(function (state) { return state.login.isLoggedIn; });
    var _e = __read(react_1.useState(''), 2), email = _e[0], setEmail = _e[1];
    var _f = __read(react_1.useState(''), 2), otp = _f[0], setOtp = _f[1];
    var variant = react_redux_1.useSelector(function (state) { return state.login.formVariant; });
    // Google Analytics
    react_1.useEffect(function () {
        var _a;
        // Filter out redirects from private routes
        if (!((_a = location === null || location === void 0 ? void 0 : location.state) === null || _a === void 0 ? void 0 : _a.previous)) {
            ga_1.GAPageView('EMAIL LOGIN PAGE');
            ga_1.GAEvent('login page', 'email');
        }
    }, [(_b = location === null || location === void 0 ? void 0 : location.state) === null || _b === void 0 ? void 0 : _b.previous]);
    // Display a login message from the server
    react_1.useEffect(function () {
        var cancelled = false;
        requests_1.get('/api/login/message').then(function (response) {
            if (response.ok) {
                response.text().then(function (text) {
                    if (text && !cancelled)
                        setLoginInfoMessage(text);
                });
            }
        });
        return function () {
            cancelled = true;
        };
    }, []);
    // Fetch backend validation expression
    react_1.useEffect(function () {
        dispatch(actions_1.default.getEmailValidationGlobExpression());
        return;
    }, [getEmailValidator]);
    if (!isLoggedIn) {
        var variantMap = types_1.loginFormVariants.map[variant];
        var isEmailView = types_1.loginFormVariants.isEmailView(variant);
        var emailError_1 = function () { return !!email && !emailValidator(email); };
        var formAttr = isEmailView
            ? {
                id: 'email',
                onSubmit: function (e) {
                    e.preventDefault();
                    dispatch(actions_1.default.getOTPEmail(email));
                    ga_1.GAPageView('OTP LOGIN PAGE');
                    ga_1.GAEvent('login page', 'otp', 'successful');
                },
                placeholder: "e.g. " + i18next_1.default.t('login.placeholders.email'),
                buttonMessage: 'Sign in',
                textError: emailError_1,
                textErrorMessage: function () {
                    return emailError_1()
                        ? "This doesn't look like a valid " + i18next_1.default.t('general.emailDomain') + " email."
                        : '';
                },
                onChange: function (email) { return setEmail(email.toLowerCase()); },
                variant: variant,
                autoComplete: 'on',
                value: email,
            }
            : {
                id: 'otp',
                onSubmit: function (e) {
                    e.preventDefault();
                    dispatch(actions_1.default.verifyOTP(otp));
                },
                titleMessage: 'One time password',
                placeholder: 'e.g. 123456',
                buttonMessage: 'Submit',
                textError: function () { return false; },
                textErrorMessage: function () { return ''; },
                onChange: function (otp) { return setOtp(otp); },
                variant: variant,
                autoComplete: 'off',
                value: otp,
            };
        return (react_1.default.createElement(BaseLayout_1.default, { withHeader: false, withFooter: false, withLowFooter: false },
            react_1.default.createElement("div", { className: classes.container },
                react_1.default.createElement("div", null,
                    react_1.default.createElement(core_1.Hidden, { mdDown: true },
                        react_1.default.createElement("div", { className: classes.graphicColorFill },
                            react_1.default.createElement("img", { className: classes.loginGraphic, src: login_page_graphics_svg_1.default, alt: "Login page graphic" })))),
                react_1.default.createElement("div", { className: classes.loginContainer },
                    react_1.default.createElement("div", { className: classes.verticalAlign },
                        react_1.default.createElement(Section_1.default, null,
                            react_1.default.createElement("section", { className: classes.loginWrapper },
                                react_1.default.createElement("span", { className: classes.headerGroup },
                                    react_1.default.createElement(core_1.Link, { href: "/#/" },
                                        react_1.default.createElement("img", { className: classes.logo, src: go_main_logo_svg_1.default, alt: "GoGovSG logo" })),
                                    react_1.default.createElement(core_1.Typography, { className: classes.loginHeader, variant: "body1", dangerouslySetInnerHTML: {
                                            __html: format_1.htmlSanitizer(i18next_1.default.t('login.whitelistPhrase')),
                                        } }),
                                    false && (react_1.default.createElement(core_1.Typography, { className: classes.loginReferral, variant: "body1" },
                                        i18next_1.default.t('login.referrals.1.officerPhrase'),
                                        " can use their ",
                                        i18next_1.default.t('login.referrals.1.emailDomain'),
                                        ' ',
                                        "emails at",
                                        ' ',
                                        react_1.default.createElement(core_1.Link, { href: "https://" + i18next_1.default.t('login.referrals.1.link') }, i18next_1.default.t('login.referrals.1.link')),
                                        ", and ",
                                        i18next_1.default.t('login.referrals.2.officerPhrase'),
                                        " can use their ",
                                        i18next_1.default.t('login.referrals.2.emailDomain'),
                                        ' ',
                                        "emails at",
                                        ' ',
                                        react_1.default.createElement(core_1.Link, { href: "https://" + i18next_1.default.t('login.referrals.2.link') }, i18next_1.default.t('login.referrals.2.link')),
                                        ' ',
                                        "to shorten links."))),
                                react_1.default.createElement("span", { className: classes.textInputGroup },
                                    react_1.default.createElement(core_1.Typography, { variant: "body1" }, isEmailView ? 'Email' : 'One-time password'),
                                    react_1.default.createElement(LoginForm_1.default, __assign({}, formAttr), isEmailView ? (react_1.default.createElement(TextButton_1.default, { className: classes.secondaryButton, href: i18next_1.default.t('general.links.faq') }, "Need help?")) : (react_1.default.createElement(TextButton_1.default, { className: classnames_1.default(classes.secondaryButton, classes.resendOTPBtn), disabled: !variantMap.resendEnabled, onClick: function () {
                                            return dispatch(actions_1.default.getOTPEmail(email));
                                        } }, "Resend OTP"))),
                                    variantMap.progressBarShown ? react_1.default.createElement(core_1.LinearProgress, null) : null))))))));
    }
    if (location) {
        // ensure page re-directed back to intended private route and reset the state
        if ((_c = location === null || location === void 0 ? void 0 : location.state) === null || _c === void 0 ? void 0 : _c.previous) {
            return react_1.default.createElement(react_router_dom_1.Redirect, { to: { pathname: location.state.previous, state: {} } });
        }
        return react_1.default.createElement(react_router_dom_1.Redirect, { to: { pathname: types_1.USER_PAGE, state: { from: location } } });
    }
    return react_1.default.createElement(react_router_dom_1.Redirect, { to: { pathname: types_1.USER_PAGE } });
};
exports.default = LoginPage;
